<template>
<sidebar-widget
    :start-expanded="startExpanded"
    :sections="sections"
    :headers="['Position', 'Purpose']"
>
    <template v-slot:title>Positions</template>

    <!--
    <template v-slot:row-details="props">
        <div>
            <span>Employee Contribution: </span> <span>${{ props.row.employee_contribution }}%</span><br />
            <span>Employer Match: </span> <span>${{ props.row.employer_match }}%</span><br />
        </div>
    </template>
    -->
</sidebar-widget>

</template>

<script>
import SidebarWidget from './SidebarWidget'

export default {
    props: ['bankAccount', 'startExpanded', ],
    components: {SidebarWidget, },
    computed: {
        sections() {
            let positions = {}
            this.bankAccount.net_pay_positions.forEach(p => {
                if (!positions.hasOwnProperty(p.id)) {
                    positions[p.id] = {
                        position: p,
                        purposes: []
                    }
                }

                positions[p.id].purposes.push('Net Pay')
            })

            this.bankAccount.taxes_positions.forEach(p => {
                if (!positions.hasOwnProperty(p.id)) {
                    positions[p.id] = {
                        position: p,
                        purposes: []
                    }
                }

                positions[p.id].purposes.push('Taxes')
            })

            positions = Array.from(Object.values(positions))
            positions.sort((a, b) => {
                return (a.position.terminal_value > b.position.terminal_value) ? 1 : -1
            })

            const rows = []
            positions.forEach(p => {
                const purposes = Array.from(p.purposes)
                purposes.sort((a, b) => (a > b) ? 1 : -1)

                rows.push({
                    cells: [
                        p.position.terminal_value,
                        purposes.join(', ')
                    ],
                    id: Math.random(),
                })
            })

            return [{title: 'Main', rows: rows}]
        },
    },
}
</script>
